module.exports = __webpack_public_path__ + "img/王金地1.80dbdb86.jpg";